module.exports = __webpack_public_path__ + "img/triangle-instrument.3ef01283.svg";